import React from "react";
import { Avatar } from "@mui/material";
import { organisingCommittee } from "../data/members";

const OrganisingTeam = () => {
  return (
    <div className="flex flex-col items-stretch"> {/* Matched with AdvisoryTeam layout */}
      {[...organisingCommittee].map(({ name, avatar, title, url, position }, index) => {
        return (
          <div className="flex flex-row items-center gap-4 my-4" key={`organising-committee-${index}`}> {/* Layout matched */}
            <Avatar 
              src={avatar} 
              alt={name}
              style={{ width: "120px", height: "120px" }} // Consistent size
            />
            <div className="text-left">
              {url ? (
                <a href={url} rel="noreferrer" target="_blank" className="hover:underline">
                  <p className="text-lg font-semibold">
                    <span className="font-normal italic">{title}.</span>
                    &nbsp;{name}
                  </p>
                </a>
              ) : (
                <p className="text-lg font-semibold">
                  <span className="font-normal italic">{title}.</span>
                  &nbsp;{name}
                </p>
              )}
              <p className="text-semibold text-blue-950">
                {position}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrganisingTeam;